import { render, staticRenderFns } from "./AlertSeverityChart.vue?vue&type=template&id=0dc41ead"
import script from "./AlertSeverityChart.vue?vue&type=script&lang=js"
export * from "./AlertSeverityChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports